import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import style from './Banner.module.css'

const Component: NextPage = () => {
  const Router = useRouter()
  const defaultQueryValue = (Router.pathname === '/search') && Router.query.query || ''

  const handlerSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (e.target instanceof HTMLFormElement && e.target.query) {
      const query = e.target.query.value;
      Router.push(`/project?query=${query}`);
    }
  }

  return (
    <div className={`${style.bannerWrap} flex flex-col justify-center items-center`}>
      <div>
        {/* <h2 className={`${style.bannerHead}`}> */}
        <h2 className="text-[36px] tracking-[-3px] text-center leading-[130%]">
          환경에 미칠 영향을 종합적으로 예측하고 평가하여<br />
          <span className='font-medium text-gg-green'>건전하고</span> <span className='font-medium text-gg-blue'>지속가능한</span> 개발을 조성합니다.
        </h2>
        <p className='mt-4 text-center text-[18px] text-[#666666] font-light'>
          환경영향평가 진행상황을 알려드립니다.
        </p>
      </div>
      <div>
        <form onSubmit={handlerSubmit}>
        <div className='flex w-[740px] h-[66px] my-8'>
            <input
              type="search"
              required
              minLength={1}
              maxLength={20}
              autoComplete='on'
              name="query"
              placeholder="사업명을 입력하세요"
              defaultValue={defaultQueryValue}
              className='flex-grow px-6 border-3 border-gg-blue focus:!ring-0 focus:!outline-0 focus:!border-gg-blue placeholder:text-[16px] placeholder:font-light placeholder:text-[#999999]'
            />
            <button type="submit" className='w-[150px] border-gg-secondary bg-gg-blue text-white'>검색</button>
        </div>
        </form>
      </div>
    </div>
  )
}

export default Component
